import { apiClient, Auth } from '@/shared/api'

import { THostSamsamCareLink } from '../model/schema'

export const getHostSamsamCareLink = async (initialContractId: number) => {
  const response = await apiClient.get<THostSamsamCareLink>({
    endpoint: `/host/contracts/masters/${initialContractId}/care-link`,
    auth: Auth.REQUIRED,
  })

  return response
}
